export default __webpack_public_path__ + "static/media/check.f8c60943.svg";